import '@angular/compiler';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageDatasetInstructionDetailComponent } from './page.dataset.instruction.detail/page.dataset.instruction.detail.component';
import { PageDatasetFinetuneDetailComponent } from './page.dataset.finetune.detail/page.dataset.finetune.detail.component';
import { PageCollectionsComponent } from './page.collections/page.collections.component';
import { PageReviewDetailComponent } from './page.review.detail/page.review.detail.component';
import { PageDatasetInstructionComponent } from './page.dataset.instruction/page.dataset.instruction.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageDatasetFinetuneComponent } from './page.dataset.finetune/page.dataset.finetune.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageUserComponent } from './page.user/page.user.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageDpiComponent } from './page.dpi/page.dpi.component';
import { PageRefactoringComponent } from './page.refactoring/page.refactoring.component';
import { PageReportComponent } from './page.report/page.report.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageSetComponent } from './page.set/page.set.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PageReviewComponent } from './page.review/page.review.component';
import { PageAccessComponent } from './page.access/page.access.component';

const INDEX_PAGE = "access";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "dataset/instruction/:id",
                component: PageDatasetInstructionDetailComponent,
                "app_id": "page.dataset.instruction.detail"
            },
            {
                "path": "dataset/finetune/:id",
                component: PageDatasetFinetuneDetailComponent,
                "app_id": "page.dataset.finetune.detail"
            },
            {
                "path": "collections/:id?",
                component: PageCollectionsComponent,
                "app_id": "page.collections"
            },
            {
                "path": "review/:id",
                component: PageReviewDetailComponent,
                "app_id": "page.review.detail"
            },
            {
                "path": "dataset/instruction",
                component: PageDatasetInstructionComponent,
                "app_id": "page.dataset.instruction"
            },
            {
                "path": "dataset/finetune",
                component: PageDatasetFinetuneComponent,
                "app_id": "page.dataset.finetune"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "user",
                component: PageUserComponent,
                "app_id": "page.user"
            },
            {
                "path": "refactoring",
                component: PageRefactoringComponent,
                "app_id": "page.refactoring"
            },
            {
                "path": "report",
                component: PageReportComponent,
                "app_id": "page.report"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "admin",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "review",
                component: PageReviewComponent,
                "app_id": "page.review"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "dpi",
                component: PageDpiComponent,
                "app_id": "page.dpi"
            },
            {
                "path": "set",
                component: PageSetComponent,
                "app_id": "page.set"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }